module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-5-1f4269e9a8ffbec6e4cf83be7a1524ae.webp";